import { useState, useEffect } from  'react';

import appConstants from '../../../../constants';

function getListSelectedItems(list, listItemIsSelectedKey) {
  return list.filter(listItem => listItem[listItemIsSelectedKey] === true);
}

export default function useSearchCriteria(
  selectedSearchForm,

  countryFilterValues,

  partnerRoleFilterValues,
  partnerExpertiseFilterValues,
  partnerLevelFilterValues,

  selectedPartnerNameSuggestion,
  selectedPartnerIntegratorLevelSuggestions,
  selectedPartnerProviderLevelSuggestions,
  selectedPartnerDeveloperLevelSuggestions,
  selectedPartnerAdvisorLevelSuggestions,
  selectedPartnerIntegratorSpecializationSuggestions,
  selectedPartnerProviderCiscoPoweredServiceSuggestions,

  isSearchRestorationInProgress,
  isUserGeoLocationCompleted
  //selectedSearchTermsAsPartnerName,
  //unselectSearchedTermsAsPartnerName
) {
  const [searchCriteria, setSearchCriteria] = useState([]);
  const [derivedSelectedPartnerRoleCode, setDerivedSelectedPartnerRoleCode] = useState(null);


  useEffect(
    () => {

      if (isUserGeoLocationCompleted) {
        let sc = [];
        switch (selectedSearchForm) {
          case appConstants.SEARCH_FORM_FILTER_BY_NEED:

            sc = sc.concat(
              getListSelectedItems(countryFilterValues, appConstants.KEY_IS_SELECTED),
              getListSelectedItems(partnerRoleFilterValues, appConstants.KEY_IS_SELECTED),
              getListSelectedItems(partnerExpertiseFilterValues, appConstants.KEY_IS_SELECTED),
              getListSelectedItems(partnerLevelFilterValues, appConstants.KEY_IS_SELECTED)
            );
            setDerivedSelectedPartnerRoleCode(previousValue => null);
            setSearchCriteria(previousValue => sc);
            break;

          case appConstants.SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA:

            sc = sc.concat(
              getListSelectedItems(countryFilterValues, appConstants.KEY_IS_SELECTED),
              !!selectedPartnerNameSuggestion ? [selectedPartnerNameSuggestion]:[],
              selectedPartnerIntegratorLevelSuggestions,
              selectedPartnerProviderLevelSuggestions,
              selectedPartnerDeveloperLevelSuggestions,
              selectedPartnerAdvisorLevelSuggestions,
              selectedPartnerIntegratorSpecializationSuggestions,
              selectedPartnerProviderCiscoPoweredServiceSuggestions
            )
            if(
              !!selectedPartnerIntegratorLevelSuggestions.length &&
              !selectedPartnerProviderLevelSuggestions.length &&
              !selectedPartnerDeveloperLevelSuggestions.length &&
              !selectedPartnerAdvisorLevelSuggestions.length
            ) {
              setDerivedSelectedPartnerRoleCode(appConstants.VALUE_INTEGRATOR);
            }
            else {
              if(
                !selectedPartnerIntegratorLevelSuggestions.length &&
                !!selectedPartnerProviderLevelSuggestions.length &&
                !selectedPartnerDeveloperLevelSuggestions.length &&
                !selectedPartnerAdvisorLevelSuggestions.length
              ) {
                setDerivedSelectedPartnerRoleCode(appConstants.VALUE_PROVIDER);
              }
              else {
                if(
                  !selectedPartnerIntegratorLevelSuggestions.length &&
                  !selectedPartnerProviderLevelSuggestions.length &&
                  !!selectedPartnerDeveloperLevelSuggestions.length &&
                  !selectedPartnerAdvisorLevelSuggestions.length
                ) {
                  setDerivedSelectedPartnerRoleCode(appConstants.VALUE_DEVELOPER);
                }
                else {
                  if(
                    !selectedPartnerIntegratorLevelSuggestions.length &&
                    !selectedPartnerProviderLevelSuggestions.length &&
                    !!selectedPartnerDeveloperLevelSuggestions.length &&
                    !selectedPartnerAdvisorLevelSuggestions.length
                  ) {
                    setDerivedSelectedPartnerRoleCode(appConstants.VALUE_DEVELOPER);
                  }
                  else {
                    if(
                      !selectedPartnerIntegratorLevelSuggestions.length &&
                      !selectedPartnerProviderLevelSuggestions.length &&
                      !selectedPartnerDeveloperLevelSuggestions.length &&
                      !!selectedPartnerAdvisorLevelSuggestions.length
                    ) {
                      setDerivedSelectedPartnerRoleCode(appConstants.VALUE_ADVISOR);
                    }
                    else {
                      setDerivedSelectedPartnerRoleCode(null);
                    }
                  }
                }
              }
            }
            //if (selectedPartnerIntegratorLevelSuggestions.length > 0) {
            //  if (selectedPartnerProviderLevelSuggestions.length > 0) {
            //    setDerivedSelectedPartnerRoleCode(previousValue => null);
            //  }
            //  else {
            //    setDerivedSelectedPartnerRoleCode(appConstants.VALUE_INTEGRATOR);
            //  }
            //}
            //else {
            //  if (selectedPartnerProviderLevelSuggestions.length > 0) {
            //    setDerivedSelectedPartnerRoleCode(appConstants.VALUE_PROVIDER);
            //  }
            //  else {
            //    setDerivedSelectedPartnerRoleCode(previousValue => null);
            //  }
            //}
            setSearchCriteria(previousValue => sc);
            break;

          case appConstants.SEARCH_FORM_SEARCH_BY_LOCATION:
          default :

            setDerivedSelectedPartnerRoleCode(previousValue => null);
            break;
        }
      }

    },
    [
      selectedSearchForm,

      countryFilterValues,

      partnerExpertiseFilterValues,
      partnerLevelFilterValues,

      selectedPartnerNameSuggestion,
      selectedPartnerIntegratorLevelSuggestions,
      selectedPartnerProviderLevelSuggestions,
      selectedPartnerDeveloperLevelSuggestions,
      selectedPartnerAdvisorLevelSuggestions,
      selectedPartnerIntegratorSpecializationSuggestions,
      selectedPartnerProviderCiscoPoweredServiceSuggestions,
      isSearchRestorationInProgress,
      isUserGeoLocationCompleted
    ]
  );

  return {
    searchCriteria,
    derivedSelectedPartnerRoleCode
  }
}
